import { CreatedItemResponseDTO } from "@/domain/dto/CreatedItemResponseDTO";
import { CreatePartnerDTO } from "@/domain/dto/CreatePartnerDTO";
import { IPartnerRepository } from "@/domain/repositories/IPartnerRepository";
import { ICreatePartnerUseCase } from "@/domain/usecases/ICreatePartnerUseCase";
import { PartnerValidator } from "../validators/PartnerValidator";
import { NewPartnerCreatedDTO } from "@/domain/dto/NewPartnerCreatedDTO";

export class CreatePartnerUseCase implements ICreatePartnerUseCase {
    repository: IPartnerRepository
    constructor(repository: IPartnerRepository) {
        this.repository = repository
    }
    execute(params: CreatePartnerDTO): Promise<NewPartnerCreatedDTO> {
        PartnerValidator.validateCreate(params)
        return this.repository.create(params)
    }

}